
import React, {Component} from 'react'
import {Modal} from 'react-bootstrap'
import PurchaseOrderDoc from './PurchaseOrderDoc'
import PurchaseFromWorkRecordModal from './PurchaseFromWorkRecordModal'
import PODocStore  from '../../stores/PODocStore'
class PurchaseOrderDocFromWorkModal extends Component {

  constructor(...args){
    super(...args)
    this.state = {newDocModal:false,itemList:[],workNo:'',list:[],showRec:false,showDoc:false}
  }

  // componentWillReceiveProps(newProps) {
  //   if (newProps.show && newProps.show!==this.props.show)
  //     this.loadRecord()
  // }

  loadRecord(workNo) {
    PODocStore.loadWorkRecord(workNo,(result)=>{
      if (result.data.list.length>0) 
        this.setState({showRec:true,showDoc:false,list:result.data.list})
      else
        this.setState({newDocModal:true,showRec:false,showDoc:true})
    },()=>{

    })
  }

  callNewDoc(itemList,workNo) {
    this.setState({itemList:itemList,workNo:workNo})
    this.loadRecord(workNo)
  }

  onNewDoc() {
    this.setState({newDocModal:true,showRec:false,showDoc:true})
  }

  onSelectItem(item) {
    this.setState({showRec:false,showDoc:true})
    setTimeout(()=>{
      this.refs.poDoc.loadData(item.purchase_order_no)
    },100)
  }

  onDocClose(){
    this.props.onHide()
  }

  render(){
    let {show} = this.props
    let {newDocModal,itemList,workNo,showRec,showDoc} = this.state
    return (
      <div>
        <PurchaseFromWorkRecordModal 
          show={showRec} 
          list={this.state.list}
          onHide={()=>{this.setState({showRec:false});this.props.onHide();}}
          onSelectItem={this.onSelectItem.bind(this)}
          onNewDoc={this.onNewDoc.bind(this)}
        />
        <Modal 
            show={showDoc && show}
            onHide={()=>{this.setState({showRec:false}); this.props.onHide();}}
            enforceFocus={false}
            dialogClassName="fullwidth-dialog"
        >
            <Modal.Body>
                <PurchaseOrderDoc 
                    ref='poDoc' 
                    newDocModal={newDocModal}
                    itemList={itemList}
                    workNo={workNo}
                    onClose={this.onDocClose.bind(this)}
                />
            </Modal.Body>   
        </Modal>  
      </div>
    )
  }
}

PurchaseOrderDocFromWorkModal.defaultProps = {
  show: false,
  workNo: ''
}


export default PurchaseOrderDocFromWorkModal;








// WEBPACK FOOTER //
// ./src/view/po/PurchaseOrderDocFromWorkModal.js